import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={20} viewBox="0 0 20 20" width={20} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.5 10A7.5 7.5 0 1 1 10 2.5c2.071 0 3.946.832 5.303 2.197m0 0v-3.03m0 3.03h-3.03"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgRefresh;
export { SvgRefresh };
